var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24777_23381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5166 9.1665H9.6416",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5791 1.60411C7.76144 1.42177 8.00874 1.31934 8.2666 1.31934C8.39428 1.31934 8.52071 1.34448 8.63867 1.39335C8.75664 1.44221 8.86382 1.51382 8.9541 1.60411C9.04439 1.69439 9.116 1.80157 9.16486 1.91954C9.21373 2.0375 9.23887 2.16393 9.23887 2.29161C9.23887 2.41929 9.21373 2.54572 9.16486 2.66368C9.116 2.78164 9.04439 2.88882 8.9541 2.97911L3.22493 8.70827L1.3916 9.16661L1.84993 7.33327L7.5791 1.60411Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24777_23381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0.0166016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit4);
export default __webpack_public_path__ + "static/media/edit-4.078df591be027820413fea44e8e757f7.svg";
export { ForwardRef as ReactComponent };